const CloudTransition = () => {
  return (
    <div className="relative h-64 w-full overflow-hidden">
      <style>{`
        .bg-gradient-cloud-to-dark {
          background: linear-gradient(
            180deg,
            hsl(0 0% 100%) 0%,
            hsl(210 20% 98%) 15%,
            hsl(210 30% 90%) 30%,
            hsl(215 35% 75%) 45%,
            hsl(220 40% 55%) 60%,
            hsl(222 45% 30%) 80%,
            hsl(222 47% 11%) 100%
          );
        }
      `}</style>
      
      {/* Base gradient background */}
      <div className="absolute inset-0 bg-gradient-cloud-to-dark" />
      
      {/* Cloud effects for smooth transition */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Top clouds - blending from white */}
        <div className="absolute -top-16 left-0 w-full h-40 bg-gradient-to-b from-white/90 to-transparent" />
        <div className="absolute -top-10 left-[5%] w-[35%] h-32 bg-white/80 rounded-full blur-3xl" />
        <div className="absolute -top-5 left-[15%] w-72 h-28 bg-white/70 rounded-full blur-2xl" />
        <div className="absolute -top-12 left-[30%] w-56 h-32 bg-white/85 rounded-full blur-xl" />
        <div className="absolute top-0 right-[20%] w-80 h-32 bg-white/60 rounded-full blur-3xl" />
        <div className="absolute -top-8 right-[8%] w-64 h-28 bg-white/75 rounded-full blur-2xl" />
        <div className="absolute -top-5 right-0 w-[30%] h-32 bg-white/65 rounded-full blur-3xl" />
        
        {/* Upper-middle layer clouds */}
        <div className="absolute top-20 left-[10%] w-48 h-20 bg-white/40 rounded-full blur-2xl" />
        <div className="absolute top-24 left-[45%] w-56 h-24 bg-white/35 rounded-full blur-3xl" />
        <div className="absolute top-18 right-[15%] w-52 h-22 bg-white/45 rounded-full blur-2xl" />
        
        {/* Lower-middle layer clouds */}
        <div className="absolute top-36 left-[20%] w-44 h-18 bg-white/20 rounded-full blur-2xl" />
        <div className="absolute top-40 left-[60%] w-48 h-20 bg-white/15 rounded-full blur-3xl" />
        <div className="absolute top-38 right-[25%] w-40 h-16 bg-white/25 rounded-full blur-2xl" />
        
        {/* Bottom clouds - blending to dark */}
        <div className="absolute bottom-8 left-[8%] w-[28%] h-24 bg-gray-900/30 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-[25%] w-64 h-28 bg-gray-900/25 rounded-full blur-2xl" />
        <div className="absolute bottom-5 left-[50%] w-56 h-24 bg-gray-900/30 rounded-full blur-xl" />
        <div className="absolute bottom-2 right-[20%] w-72 h-32 bg-gray-900/35 rounded-full blur-3xl" />
        <div className="absolute bottom-4 right-[5%] w-60 h-28 bg-gray-900/35 rounded-full blur-2xl" />
        
        {/* Bottom gradient overlay to ensure smooth transition */}
        <div className="absolute -bottom-16 left-0 w-full h-40 bg-gradient-to-t from-gray-900/70 to-transparent" />
      </div>
    </div>
  );
};

export default CloudTransition;